import React from 'react'
import { Field, FieldProps } from 'formik'
import { InputField, FormFieldStatus } from '@gousto-internal/citrus-react'

const AddressPostcodeInput = () => (
  <Field name="postcode">
    {({ field, meta }: FieldProps) => (
      <InputField
        id="postcode"
        label="Postcode"
        placeholder="ex. SW1A 2AA"
        autoComplete="postal-code"
        status={meta.error ? FormFieldStatus.Error : undefined}
        validationMessage={meta.error}
        {...field}
      />
    )}
  </Field>
)

export { AddressPostcodeInput }
